module.exports = __webpack_public_path__ + "static/media/91smart.1b6bffbf.png";